import {Injectable, Signal, signal} from '@angular/core';
import {ResponsiveColDirective} from './responsive-col.directive';

@Injectable()
export class ResponsiveColsService {

    public readonly cols: Signal<ResponsiveColDirective[]>;

    private readonly colsSignal = signal<ResponsiveColDirective[]>([]);

    constructor() {
        this.cols = this.colsSignal.asReadonly();
    }

    public registerCol(col: ResponsiveColDirective): void {
        this.colsSignal.update(cols => [...cols, col]);
    }

    public unregisterCol(col: ResponsiveColDirective): void {
        this.colsSignal.update(cols => cols.filter(c => c !== col));
    }

}
